import { useTranslation } from 'react-i18next'

import { MapPinIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const Heading = ({ title, explanation }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Styles.Container>
      <Styles.TitleContainer>
        <MapPinIcon size={24} weight="thin" color={theme.colors.grey.tone700} />
        <Text type="bodyLBold">{t(title)}</Text>
      </Styles.TitleContainer>
      <Text type="bodyMRegular">{t(explanation)}</Text>
    </Styles.Container>
  )
}

export default Heading
